<template>
	<b-container class="rb-layout-default" fluid>
		<div class="layout-background"></div>
		<rb-particles v-if="siteSettings.particlesEnabled"></rb-particles>

		<!-- Header -->
		<b-container fluid class="rb-head">
			<b-row align-h="between">
				<b-col cols="auto" class="p-0">
					<!-- Logo -->
					<router-link to="/">
						<img src="./assets/logo.png" class="logo">
					</router-link>
				</b-col>

				<b-col cols="auto" class="rb-auth">
					<!-- Auth -->
					<rb-avatar></rb-avatar>
					<div class="rb-logged-user" v-if="loggedUser">
						<h5 class="m-0">
							{{ loggedUser.Name }}
						</h5>
						<span class="text-xs font-title">
							<router-link to="/account">Minha conta</router-link>
							<span class="text-grey">&nbsp;&middot;&nbsp;</span>
							<a class="text-danger" :href="logoutUrl">Sair</a>
						</span>
					</div>
				</b-col>
			</b-row>
		</b-container>

		<!-- Navigation -->
		<b-container fluid class="rb-nav">
			<b-row align-h="between">
				<b-col cols="auto" class="links">
					<!-- Menu -->
					<router-link :to="{name: 'home'}">Início</router-link>
					<router-link :to="{name: 'videos'}">Vídeos</router-link>
					<router-link :to="{name: 'soundtracks'}">OSTs</router-link>
				</b-col>

				<b-col cols="auto" class="social text-right">
					<a
						href="#" class="snow-icon" :class="{'snow-off': !siteSettings.particlesEnabled}"
						@click.prevent.stop="siteSettings.particlesEnabled = !siteSettings.particlesEnabled"
					>
						<rb-icon>snowflake</rb-icon>
					</a>

					&middot;

					<!-- Social -->
					<a href="https://www.facebook.com/RWBYBrasil/" target="_blank">
						<rb-icon brand>facebook-f</rb-icon>
					</a>
					<a href="https://www.instagram.com/rwby.brasil/" target="_blank">
						<rb-icon brand>instagram</rb-icon>
					</a>
					<a href="https://discord.gg/9Njfv5P" target="_blank">
						<rb-icon brand>discord</rb-icon>
					</a>
				</b-col>
			</b-row>
		</b-container>

		<!-- Content -->
		<b-container fluid class="rb-content">
			<b-row class="rb-content-page">
				<slot></slot>
			</b-row>

			<!-- Footer -->
			<b-row class="rb-footer">
				<b-col class="text-center">
					<span style="opacity: .8;">
						RWBY &copy; <a href="https://roosterteeth.com" target="_blank">RoosterTeeth LLC.</a> 2019
					</span>

					<br>

					<router-link to="/privacy" style="opacity: .5;">Política de Privacidade</router-link>
				</b-col>
			</b-row>
		</b-container>

		<b-container fluid class="rb-fade"></b-container>
	</b-container>
</template>

<script>
	import RbParticles from '../components/RbParticle/RbParticles';
	import RbAvatar from '../components/RbAvatar';
	import {mapState} from 'vuex';
	import StorageObject from '../../../shared/util/StorageObject';

	let settingsStorage = new StorageObject('rb_site_');
	let siteSettings = {
		get particlesEnabled() {
			return settingsStorage.get('particlesEnabled', true);
		},
		set particlesEnabled(val) {
			settingsStorage.set('particlesEnabled', val);
		}
	};

	export default {
		name: 'DefaultLayout',
		components: {RbAvatar, RbParticles},
		data:() => ({
			siteSettings
		}),
		computed: {
			...mapState([
				'loggedUser'
			]),
			logoutUrl() {
				return this.$oldApi.getUrl({url: 'Auth.Logout', params: {'origin-url': 'h'+window.location}})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.rb-head {
		.logo {
			height: 125px;
		}
		
		.rb-auth {
			text-align: right;

			.rb-logged-user {
				* {
					line-height: 1em;
				}
			}

			@include media-breakpoint-down(sm) {
				.rb-avatar {
					float: right;
					margin-left: 10px;
				}

				.rb-logged-user {
					float: left;
					margin-top: 25px;
				}
			}
		}

		@include media-breakpoint-down(sm) {
			.logo {
				height: 75px;
			}
		}
	}

	.rb-nav {
		font-family: $font-title;
		font-size: $font-size-xl;
		background: rgba(0, 0, 0, 0.66);
		padding-bottom: 5px;

		.links > a {
			display: inline-block;
			font-weight: 300;
			margin: 0 .5em;

			&.router-link-exact-active {
				color: $primary-2;
			}
		}

		.social {
			.snow-icon {
				transition: all linear .3s;

				&.snow-off {
					opacity: .5;

					/deep/ > * {
						transform: rotate(-180deg);
					}
				}

				/deep/ > * {
					transition: filter ease .3s, transform cubic-bezier(.32,1.6,.62,1.02) .4s;
				}
			}

			.rb-icon {
				margin: 0 .2em;

				&.fa-discord {
					transform: translateY(2px);
				}
			}
		}
	}

	.rb-content {
		background: rgba(0, 0, 0, 0.33);

		.rb-content-page {
			min-height: 100vh;
		}
	}

	// Layout
	.rb-layout-default {
		.layout-background {
			position: fixed;
			left: -5px;
			right: -5px;
			top: -5px;
			bottom: -5px;
			background: url("../assets/bck-mantle.jpg") #0D1625 top center fixed;
			background-size: cover;
			z-index: -100;
			transform: scale(1.1);
			filter: blur(5px);
		}
		position: relative;
		z-index: 1;
		padding: 0;
	}

	@include media-breakpoint-up(xl) {
		.rb-layout-default {
			padding: 0 2%;
		}
	}

	.rb-footer {
		padding: 25px 0 0;
		font-size: $font-size-xs;
	}

	.rb-fade {
		background: linear-gradient(to top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, .33) 100%);
		height: 150px;
	}
</style>
